export const parseServicesToString = (params = [], separator = '_') => params
    .filter(param => param)
    .join(separator);
